"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import UiDialog from "../../../../components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { AccountSessionMixins } from "@/service/account-session";
import UiSubmit from "@/components/form/UiSubmit.vue";
import Question from "@/components/Question.vue";
export class EditPowerController extends UiFormController {
  constructor() {
    super(...arguments);
    this.user_guids = [];
    this.powers = [];
  }
}
let EditSubAccountPower = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.formcontroller = new EditPowerController();
    this.powers_item = [
      {
        key: "VD_NEW",
        name: this.$t("team_management.action_power.dialog.vd_new")
      },
      {
        key: "VD_RENEW",
        name: this.$t("team_management.action_power.dialog.vd_renew")
      },
      {
        key: "RECHARGE_COIN",
        name: this.$t("team_management.action_power.dialog.recharge_coin")
      },
      {
        key: "VD_UPGRADE",
        name: this.$t("team_management.action_power.dialog.vd_upgrade")
      },
      {
        key: "VIEW_ORDER_DETAIL",
        name: this.$t("team_management.action_power.dialog.view_order_detail")
      },
      {
        key: "SELECT_SHOP_PASSWORD",
        name: this.$t("team_management.action_power.dialog.select_shop_password")
      },
      // {
      //   key: "EDIT_SHOP_PASSWORD",
      //   name: this.$t("team_management.other_way.dialog.edit_shop_password"),
      // },
      {
        key: "PLUG_MANAGEMENT",
        name: this.$t("team_management.action_power.dialog.extensions_manager"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_manager_question"
        )
      },
      {
        key: "PLUG_MANAGEMENT_PERSON",
        name: this.$t("team_management.action_power.dialog.extensions_install"),
        question: this.$t(
          "team_management.action_power.dialog.extensions_install_question"
        )
      },
      {
        key: "VIDEO_AUTH",
        name: this.$t("team_management.action_power.dialog.add_video")
      },
      {
        key: "SHOP_EDIT",
        name: this.$t("team_management.action_power.shop_edit")
      },
      {
        key: "PASSWORD_EDIT",
        name: this.$t("team_management.other_way.dialog.allow_edit")
      },
      {
        key: "COOKIE_BACKUP",
        name: this.$t("team_management.other_way.dialog.cookie_backup")
      },
      {
        key: "VD_LIST_MODE_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.vd_list_mode")
      },
      {
        key: "VD_NAME_INVISIBLE",
        name: this.$t("team_management.other_way.dialog.vd_name_invisible")
      },
      {
        key: "SHOP_CREATE",
        name: this.$t("team_management.other_way.dialog.shop_create")
      },
      {
        key: "FORBIDDEN_AUTH_VD_MANAGER",
        name: this.$t(
          "team_management.other_way.dialog.forbidden_auth_vd_manager"
        )
      },
      {
        key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
        name: this.$t("team_management.other_way.dialog.admin_disallow_modify_self_power")
      }
    ];
    this.guids = [];
  }
  open(data) {
    return __async(this, null, function* () {
      try {
        if (this.$session.marks.is("OPEN_API")) {
          this.powers_item = [
            {
              key: "VD_NEW",
              name: this.$t("team_management.action_power.dialog.vd_new")
            },
            {
              key: "VD_RENEW",
              name: this.$t("team_management.action_power.dialog.vd_renew")
            },
            {
              key: "RECHARGE_COIN",
              name: this.$t("team_management.action_power.dialog.recharge_coin")
            },
            {
              key: "VD_UPGRADE",
              name: this.$t("team_management.action_power.dialog.vd_upgrade")
            },
            {
              key: "VIEW_ORDER_DETAIL",
              name: this.$t(
                "team_management.action_power.dialog.view_order_detail"
              )
            },
            {
              key: "SELECT_SHOP_PASSWORD",
              name: this.$t(
                "team_management.action_power.dialog.select_shop_password"
              )
            },
            // {
            //   key: "EDIT_SHOP_PASSWORD",
            //   name: this.$t("team_management.other_way.dialog.edit_shop_password"),
            // },
            {
              key: "PLUG_MANAGEMENT",
              name: this.$t(
                "team_management.action_power.dialog.extensions_manager"
              ),
              question: this.$t(
                "team_management.action_power.dialog.extensions_manager_question"
              )
            },
            {
              key: "PLUG_MANAGEMENT_PERSON",
              name: this.$t(
                "team_management.action_power.dialog.extensions_install"
              ),
              question: this.$t(
                "team_management.action_power.dialog.extensions_install_question"
              )
            },
            {
              key: "VIDEO_AUTH",
              name: this.$t("team_management.action_power.dialog.add_video")
            },
            {
              key: "SHOP_EDIT",
              name: this.$t("team_management.action_power.shop_edit")
            },
            {
              key: "PASSWORD_EDIT",
              name: this.$t("team_management.other_way.dialog.allow_edit")
            },
            {
              key: "COOKIE_BACKUP",
              name: this.$t("team_management.other_way.dialog.cookie_backup")
            },
            {
              key: "OPEN_API",
              name: this.$t("team_management.action_power.open_api")
            },
            {
              key: "VD_LIST_MODE_INVISIBLE",
              name: this.$t("team_management.other_way.dialog.vd_list_mode")
            },
            {
              key: "VD_NAME_INVISIBLE",
              name: this.$t("team_management.other_way.dialog.vd_name_invisible")
            },
            {
              key: "SHOP_CREATE",
              name: this.$t("team_management.other_way.dialog.shop_create")
            },
            {
              key: "FORBIDDEN_AUTH_VD_MANAGER",
              name: this.$t(
                "team_management.other_way.dialog.forbidden_auth_vd_manager"
              )
            },
            {
              key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
              name: this.$t("team_management.other_way.dialog.admin_disallow_modify_self_power")
            }
          ];
        } else {
          this.powers_item = [
            {
              key: "VD_NEW",
              name: this.$t("team_management.action_power.dialog.vd_new")
            },
            {
              key: "VD_RENEW",
              name: this.$t("team_management.action_power.dialog.vd_renew")
            },
            {
              key: "RECHARGE_COIN",
              name: this.$t("team_management.action_power.dialog.recharge_coin")
            },
            {
              key: "VD_UPGRADE",
              name: this.$t("team_management.action_power.dialog.vd_upgrade")
            },
            {
              key: "VIEW_ORDER_DETAIL",
              name: this.$t(
                "team_management.action_power.dialog.view_order_detail"
              )
            },
            {
              key: "SELECT_SHOP_PASSWORD",
              name: this.$t(
                "team_management.action_power.dialog.select_shop_password"
              )
            },
            // {
            //   key: "EDIT_SHOP_PASSWORD",
            //   name: this.$t("team_management.other_way.dialog.edit_shop_password"),
            // },
            {
              key: "PLUG_MANAGEMENT",
              name: this.$t(
                "team_management.action_power.dialog.extensions_manager"
              ),
              question: this.$t(
                "team_management.action_power.dialog.extensions_manager_question"
              )
            },
            {
              key: "PLUG_MANAGEMENT_PERSON",
              name: this.$t(
                "team_management.action_power.dialog.extensions_install"
              ),
              question: this.$t(
                "team_management.action_power.dialog.extensions_install_question"
              )
            },
            {
              key: "VIDEO_AUTH",
              name: this.$t("team_management.action_power.dialog.add_video")
            },
            {
              key: "SHOP_EDIT",
              name: this.$t("team_management.action_power.shop_edit")
            },
            {
              key: "PASSWORD_EDIT",
              name: this.$t("team_management.other_way.dialog.allow_edit")
            },
            {
              key: "COOKIE_BACKUP",
              name: this.$t("team_management.other_way.dialog.cookie_backup")
            },
            {
              key: "VD_LIST_MODE_INVISIBLE",
              name: this.$t("team_management.other_way.dialog.vd_list_mode")
            },
            {
              key: "VD_NAME_INVISIBLE",
              name: this.$t("team_management.other_way.dialog.vd_name_invisible")
            },
            {
              key: "SHOP_CREATE",
              name: this.$t("team_management.other_way.dialog.shop_create")
            },
            {
              key: "FORBIDDEN_AUTH_VD_MANAGER",
              name: this.$t(
                "team_management.other_way.dialog.forbidden_auth_vd_manager"
              )
            },
            {
              key: "ADMIN_DISALLOW_MODIFY_SELF_POWER",
              name: this.$t("team_management.other_way.dialog.admin_disallow_modify_self_power")
            }
          ];
        }
        let guids = [];
        for (let item of data) {
          guids.push(item.guid);
        }
        this.guids = guids;
        if (data.length === 1) {
          let response = yield API.get(
            `api://base.auth/api/v1/users/${data[0].guid}`
          );
          let keys = [];
          for (let key in response.data.user.powers) {
            keys.push(key);
          }
          this.formcontroller.powers = keys;
        }
        if (data.length > 1) {
          this.formcontroller.powers = [];
        }
        this._power_dialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let submit = yield API.post(
          `api://base.auth/api/v7/accounts/user_power`,
          {
            powers: this.formcontroller.powers,
            user_guids: this.guids
          }
        );
        this.$message.success(
          this.$t("team_management.action_power.dialog.success_message")
        );
        this._power_dialog.hide();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("power-dialog")
], EditSubAccountPower.prototype, "_power_dialog", 2);
EditSubAccountPower = __decorateClass([
  Component({
    components: {
      UiSubmit,
      UiDialog,
      UiForm,
      Question
    }
  })
], EditSubAccountPower);
export {
  EditSubAccountPower as default
};
